/**
 * @file product-cost-form.ts
 * @description Форма «Закупка и поставщик» карточки товара: состояние из
 * загруженных данных и тело запроса `PUT …/cost`.
 *
 * Вынесено из `ProductCostSection` ради правила очистки поставщика
 * (замечание владельца 2026-10-19, пункт «Отсутствует»): пустое поле уходит
 * как `null` (сервер снимает поставщика), только если поставщик был; не было —
 * поле не отправляем (`undefined` у сервера — «не трогать»).
 */

import type { ProductCost, UpsertCostInput } from "../../../lib/api-catalog";

export interface CostFormState {
  costPrice: string;
  costCurrency: string;
  /** id поставщика; `""` — не выбран или снят пунктом «Отсутствует». */
  supplierId: string;
  internalCode: string;
  notes: string;
}

export function costFormFrom(c: ProductCost | null): CostFormState {
  return {
    costPrice: c?.costPrice ?? "",
    costCurrency: c?.costCurrency ?? "RUB",
    supplierId: c?.supplierId ?? "",
    internalCode: c?.internalCode ?? "",
    notes: c?.notes ?? "",
  };
}

export function costPayload(form: CostFormState, original: ProductCost | null): UpsertCostInput {
  return {
    costPrice: form.costPrice ? parseFloat(form.costPrice) : undefined,
    costCurrency: form.costCurrency.trim() || "RUB",
    supplierId: form.supplierId || (original?.supplierId ? null : undefined),
    internalCode: form.internalCode.trim() || undefined,
    notes: form.notes.trim() || undefined,
  };
}
